// combatpro/panels/spells/SpellSlots.js
//
// Combat PRO - SpellSlots (functional migration of the spell system).
//
// Reproduces the slot loop from the spells-block template in battletracker.html:
//   ${[0, 1, 2].map(spellIdx => `<div class="spell-row">...`).join('')}
// The template emitted the three spell-row nodes directly as children of the
// spells-section (no wrapper element), so this component returns a fragment to
// keep the DOM nesting identical. The slot count (3) is preserved exactly.
//
// Handler props are received and forwarded to each SpellSlot only; none are
// implemented here. Imports only React and SpellSlot. No state, hooks, or
// business logic. Do not edit battletracker.html.

import React from 'react';
import SpellSlot from './SpellSlot';

function SpellSlots(props) {
  const index = props.index;
  return (
    <>
      {[0, 1, 2].map(spellIdx => (
        <SpellSlot
          key={spellIdx}
          index={index}
          spellIdx={spellIdx}
          onSpellChange={props.onSpellChange}
          onCastRoundChange={props.onCastRoundChange}
          onClearSpell={props.onClearSpell}
          onEditSpell={props.onEditSpell}
        />
      ))}
    </>
  );
}

export default SpellSlots;
